export default __webpack_public_path__ + "static/media/mapmarker.f1556d96.svg";